var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hamburger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14h24v-1.333h-24v1.333zM4 19.333h24v-1.333h-24v1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.276 16.276l6.533 6.533 0.943-0.943-6.533-6.533 5.59-5.59-0.943-0.943-5.59 5.59-5.724-5.724-0.943 0.943 5.724 5.724-6.667 6.667 0.943 0.943 6.667-6.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 15.667c0 0.368-0.299 0.667-0.667 0.667h-20.194c0.873 0.466 1.799 1.006 2.665 1.624 1.794 1.282 3.476 3 3.853 5.266 0.061 0.363-0.185 0.707-0.548 0.767s-0.707-0.185-0.767-0.548c-0.289-1.734-1.608-3.182-3.313-4.4-1.447-1.034-3.069-1.831-4.36-2.466-0.222-0.109-0.434-0.214-0.634-0.314-0.226-0.113-0.369-0.344-0.369-0.596s0.143-0.483 0.369-0.596c0.2-0.1 0.412-0.204 0.634-0.314 1.291-0.635 2.913-1.433 4.36-2.466 1.706-1.218 3.024-2.667 3.313-4.4 0.061-0.363 0.404-0.609 0.767-0.548s0.609 0.404 0.548 0.767c-0.378 2.266-2.059 3.984-3.853 5.266-0.866 0.619-1.792 1.158-2.665 1.624h20.194c0.368 0 0.667 0.299 0.667 0.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hamburger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14h24v-1.333h-24v1.333zM4 19.333h24v-1.333h-24v1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.276 16.276l6.533 6.533 0.943-0.943-6.533-6.533 5.59-5.59-0.943-0.943-5.59 5.59-5.724-5.724-0.943 0.943 5.724 5.724-6.667 6.667 0.943 0.943 6.667-6.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.102 2.419l13.578 13.581-13.576 13.582c-0.257-0.109-0.483-0.299-0.634-0.56-0.118-0.203-0.179-0.433-0.179-0.668v-24.708c0-0.551 0.335-1.024 0.812-1.227zM20.622 16.943l3.069 3.069-14.583 8.444 11.513-11.513zM24.888 12.679l3.743 2.168c0.637 0.369 0.855 1.185 0.486 1.822-0.117 0.202-0.284 0.369-0.486 0.486l-3.744 2.167-3.321-3.321 3.323-3.321zM9.109 3.544l14.584 8.443-3.071 3.071-11.513-11.513z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-apple",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.809 9.629c-1.168 0-2.976-1.328-4.88-1.28-2.512 0.032-4.816 1.456-6.112 3.712-2.608 4.528-0.672 11.216 1.872 14.896 1.248 1.792 2.72 3.808 4.672 3.744 1.872-0.080 2.576-1.216 4.848-1.216 2.256 0 2.896 1.216 4.88 1.168 2.016-0.032 3.296-1.824 4.528-3.632 1.424-2.080 2.016-4.096 2.048-4.208-0.048-0.016-3.92-1.504-3.968-5.984-0.032-3.744 3.056-5.536 3.2-5.616-1.76-2.576-4.464-2.864-5.408-2.928-2.464-0.192-4.528 1.344-5.68 1.344zM20.969 5.853c1.040-1.248 1.728-2.992 1.536-4.72-1.488 0.064-3.28 0.992-4.352 2.24-0.96 1.104-1.792 2.88-1.568 4.576 1.648 0.128 3.344-0.848 4.384-2.096z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.bbe9685384a9f0bd19448a928cc594a9.svg";
export { ForwardRef as ReactComponent };